import { Injectable } from "@angular/core";
import { SubjectModelSchema } from "../../_offline/models/subjectModel.schema";
import { SubjectLocation, SubjectModel } from "../../_objects/subject-model";
import { splitFolderPath } from "../../_utils/file-system-utils";
import { resolveStructureLocation } from "../../_utils/inspection-structure.utils";
import { UtilsService } from "../_utils.service";

@Injectable({
  providedIn: "root"
})
export class SubjectLocationOfflineService {
  constructor(private utils: UtilsService) {}

  /**
   * Returns the leaf location an uploaded file belongs to.
   * 'locationIdentifier' wins when provided. Otherwise the folders the file was stored in ('folderPath', or just
   * 'folderName') are resolved against the whole location tree, so a file saved in a legacy "NN_identifier" folder
   * or anywhere in a tree of "NN_display name" folders lands on its location (see resolveStructureLocation).
   */
  public getImageSubjectLocation(
    subjectModelSchema: SubjectModelSchema,
    folderName: string,
    locationIdentifier?: string,
    folderPath?: string
  ): SubjectLocation | undefined {
    const subjectModel = new SubjectModel();
    subjectModel.setSubjectModelSchema(subjectModelSchema);

    if (locationIdentifier) {
      const leafLocations: SubjectLocation[] = this.utils.getLocations(subjectModel, null);
      return leafLocations.find((location) => location.identifier === locationIdentifier);
    }

    const folderSegments = folderPath ? splitFolderPath(folderPath) : folderName ? [folderName] : [];

    return resolveStructureLocation(subjectModel.locations, folderSegments);
  }
}
